import langMiscMarketingDashboard from './langs/langMiscMarketingDashboard';
import langMiscPlayerVideoTuto from './langs/langMiscPlayerVideoTuto';

const MiscLangs = [langMiscMarketingDashboard, langMiscPlayerVideoTuto];

export default MiscLangs;
